
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MatrixFundService {
  AppUrl = '';
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  GetMatrixByStateId(TokenKey: string, StateId: string, userID: string, ProductId: string): Observable<any> {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/GetMatrixByStateId/' + StateId + '/' + userID + '/' + ProductId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }
  GetMatrixFundFilterByPage(TokenKey: string, PageNumber: string, PageSize: string, WhereCondition: string, OrderBy: string, keywordFilter: string, productId: string): Observable<any> {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/GetMatrixFundFilterByPage/' + PageNumber + '/' + PageSize + '/' + WhereCondition + '/' + OrderBy + '/' + keywordFilter + '/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAssessmentCategoryAll(TokenKey: string, productId: number): Observable<any> {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/GetMatrixFundFilterByPage/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  addupdatematrixfund(matrixfund, TokenKey: string): Observable<any> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + 'api/MatrixFund/AddUpdateMatrixFund', matrixfund, httpOptions)
      .pipe(catchError(this.handleError));
  }

  updatematrixfundDisplayOrder(TokenKey: string, matrixfund): Observable<number> {
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/UpdateMatrixFundDisplayOrder';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<number>(fullAPIPath, matrixfund, httpOptions)
      .pipe(catchError(this.handleError));
  }

  deletefund(TokenKey: string, matrixfundId: number): Observable<any[]> {
    const data = '/' + matrixfundId;
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/DeleteFund' + data;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  activeinactivefund(TokenKey: string, matrixfundId: string, isactive: string): Observable<any[]> {
    const data = '/' + matrixfundId;
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/ActiveInActiveFund' + data + '/' + isactive;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  addupdateotherrequirment(user, TokenKey: string): Observable<any> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + 'api/MatrixFund/AddUpdateOtherRequirements', user, httpOptions)
      .pipe(catchError(this.handleError));
  }

  updateotherrequirmentDisplayOrder(TokenKey: string, matrixfund): Observable<number> {
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/UpdateOtherRequirementsDisplayOrder';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<number>(fullAPIPath, matrixfund, httpOptions)
      .pipe(catchError(this.handleError));
  }

  deleteotherreq(TokenKey: string, deleteotherreqId: number): Observable<any[]> {
    const data = '/' + deleteotherreqId;
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/DeleteOtherRequirements' + data;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  GetIPCSMatrixByStateId(TokenKey: string, StateId: string, userID: string): Observable<any> {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/GetIPCSMatrixByStateId/' + StateId + '/' + userID;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetIPCSMatrixFundFilterByPage(TokenKey: string, PageNumber: string, PageSize: string, WhereCondition: string, OrderBy: string, keywordFilter: string): Observable<any> {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/GetIPCSMatrixFundFilterByPage/' + PageNumber + '/' + PageSize + '/' + WhereCondition + '/' + OrderBy + '/' + keywordFilter;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }
  UpdateIPCSmatrixfundDisplayOrder(TokenKey: string, matrixfund): Observable<number> {
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/UpdateIPCSMatrixFundDisplayOrder';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<number>(fullAPIPath, matrixfund, httpOptions)
      .pipe(catchError(this.handleError));
  }
  DeleteIPCSfund(TokenKey: string, matrixfundId: number): Observable<any[]> {
    const data = '/' + matrixfundId;
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/DeleteIPCSFund' + data;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }
  ActiveinactiveIPCSfund(TokenKey: string, matrixfundId: string, isactive: string): Observable<any[]> {
    const data = '/' + matrixfundId;
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/ActiveInActiveIPCSFund' + data + '/' + isactive;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }
  AddupdateIPCSmatrixfund(matrixfund, TokenKey: string): Observable<any> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + 'api/MatrixFund/AddUpdateIPCSMatrixFund', matrixfund, httpOptions)
      .pipe(catchError(this.handleError));
  }
  AddupdateIPCSotherrequirment(user, TokenKey: string): Observable<any> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + 'api/MatrixFund/AddUpdateIPCSOtherRequirements', user, httpOptions)
      .pipe(catchError(this.handleError));
  }
  UpdateIPCSotherrequirmentDisplayOrder(TokenKey: string, matrixfund): Observable<number> {
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/UpdateIPCSOtherRequirementsDisplayOrder';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<number>(fullAPIPath, matrixfund, httpOptions)
      .pipe(catchError(this.handleError));
  }
  DeleteIPCSotherrequirment(TokenKey: string, deleteotherreqId: number): Observable<any[]> {
    const data = '/' + deleteotherreqId;
    const fullAPIPath = this.AppUrl + 'api/MatrixFund/DeleteIPCSOtherRequirements' + data;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }
}
